import { fetchData, postData } from "axios/axiosUtils";

export async function verifyLogin(data) {
  const url = `/api/auth/`;
  return postData(url, data);
}

export async function signUpUser(data) {
  const url = `/api/users/`;
  return postData(url, data);
}

export async function updatePassword(data) {
  const url = `/api/users/reset/password`;
  return postData(url, data);
}

export async function resetPassword(params) {
  const url = `/api/users/reset/password`;
  return fetchData(url, params);
}
